import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {ProgressIndicatorService} from '../@shared';
import {StatePersistenceService} from '../service/state.persistence.service';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {

    progressIndicator: boolean = false;

    constructor(@Inject(DOCUMENT) public document: Document,
                private progressIndicatorService: ProgressIndicatorService,
                public state: StatePersistenceService) {
        progressIndicatorService.event$.subscribe((item: boolean) => this.onProgressIndicatorEvent(item));
    }

    onProgressIndicatorEvent(item: boolean): void {
        this.progressIndicator = item;
    }
}
